export type IconProps = React.SVGProps<SVGSVGElement>
export const HeartIconUnliked = ({ mode }: { mode: string }) => (
  <svg width="17" height="15" viewBox="0 0 17 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.1433 1.56604C13.3182 -0.263906 10.4315 -0.49031 8.34335 1.0327C6.14363 -0.603432 3.05345 -0.261241 1.26499 1.81652C-0.523465 3.89429 -0.401944 7.00099 1.54335 8.9327L6.71835 14.116C7.61998 15.0034 9.06672 15.0034 9.96835 14.116L15.1433 8.9327C17.1688 6.89482 17.1688 3.60391 15.1433 1.56604ZM13.9683 7.7827L8.79335 12.9577C8.6744 13.0778 8.51238 13.1454 8.34335 13.1454C8.17431 13.1454 8.01229 13.0778 7.89335 12.9577L2.71835 7.7577C1.35902 6.3682 1.35902 4.14721 2.71835 2.7577C4.10419 1.38945 6.3325 1.38945 7.71835 2.7577C7.87482 2.91546 8.08782 3.0042 8.31001 3.0042C8.53221 3.0042 8.74521 2.91546 8.90168 2.7577C10.2875 1.38945 12.5158 1.38945 13.9017 2.7577C15.2797 4.12901 15.3093 6.35014 13.9683 7.7577V7.7827Z"
      fill={mode === 'dark' ? 'white' : 'black'}
    />
  </svg>
)

export default HeartIconUnliked
